
import React from "react";
import Compound from "../Compound";
import { i18nManager } from "../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { IBusiness, IProfile } from "../../services";
import { Classname, NoseurObject } from "@rivtn/noseur";
import { CacheManager, Debugger, Utils } from "../../utils";
import UserPlaceholder from "../../assets/images/user_placeholder.png";

function SelectAccount() {
    const labels = i18nManager.Labels.oauth;
    const navigate = ReactRouterDom.useNavigate();
    const [success, setSuccess] = React.useState<boolean>();
    const { state } = ReactRouterDom.useLocation() as { state: { postOnly: boolean; isTrusted: boolean; referrer: string; profile: IProfile; business: IBusiness; permissions: NoseurObject<string>[]; } };
    const profiles = Utils.profilesWithProfile(CacheManager.get(CacheManager.PROFILES_KEY) as IProfile[], state.profile);

    React.useEffect(() => {
        Debugger.log("SelectAccount:useEffect", state, profiles);
        if (!(state?.referrer && profiles?.length && profiles?.length && state?.permissions)) {
            navigate(-1);
            return;
        }
    }, []);

    return Compound({
        success,
        isOauth: true,
        business: state?.business,
        secondaryFormElement: renderAccountForm(),
    });

    function renderAccountForm() {
        const now = (new Date()).getTime();
        const oauthRedirectPayload: any = { ref: state.referrer };
        if (state.business?.external_id) oauthRedirectPayload.bid = state.business.external_id;
        return (<div className="select-account">
            <span className="title">{labels.choose_account} <span className="n">{Utils.collapseString(state.business.name, 50)}</span></span>
            <div className={Classname.build("accounts", (success ? "noseur-disabled" : null))}>
                {profiles?.map((profile: IProfile) => {
                    const signedOut = now >= profile.session_expiry_date;
                    return (<div key={profile.email} className="account" onClick={() => {
                        if (signedOut) {
                            navigate("/", {
                                state: {
                                    ...state,
                                    profile,
                                },
                            });
                            return;
                        }
                        if (state.isTrusted) {
                            setSuccess(true);
                            Utils.redirectToReferrer(state.referrer, profile, false, state.postOnly, true);
                            return;
                        }
                        navigate("/oauth/authorize", {
                            state,
                        });
                    }}>
                        <img alt={profile.email} src={profile.profile_picture_location ?? UserPlaceholder} />
                        <span className="name">{profile.first_name} {profile.last_name}</span>
                        <span className="email">
                            {Utils.collapseString(profile.email, 15)}
                            <span className="tooltip">{profile.email}</span>
                        </span>
                        {(signedOut) && (<span className="sout">{labels.signed_out}</span>)}
                    </div>);
                })}
                <ReactRouterDom.NavLink className="account" to={{
                    pathname: "/",
                    search: ReactRouterDom.createSearchParams({ rloc: `/oauth?${ReactRouterDom.createSearchParams(oauthRedirectPayload).toString()}`, }).toString()
                }} state={state}>
                    <img alt="select account" src={UserPlaceholder} />
                    <span className="name">{labels.use_another_account}</span>
                </ReactRouterDom.NavLink>
            </div>
        </div>);
    }

}

export default SelectAccount;
